import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper.jsx';
import CardPost from '../../fragments/card/CardPost.jsx';
import CardStaff from '../../fragments/card/CardStaff.jsx';
import CardHighContent from '../../fragments/card/CardHighContent.jsx';
import CardNews from '../../fragments/card/CardNews.jsx';
import CardHero from '../../fragments/card/CardHero.jsx';

const CARD_COMPONENTS = {
  news: CardNews,
  hero: CardHero,
  content: CardHighContent,
  staff: CardStaff,
  default: CardPost,
};

export default function CardDemo({ block = {} }) {
  if (!block || !block.cards?.length) return null;

  const { cards, cardType = 'news' } = block;
  const CardComponent = CARD_COMPONENTS[cardType] || CARD_COMPONENTS.default;

  return (
    <ComponentWrapper block={block} className="BlockCardProjects">
      <div className="l-grid">
        <div className="l-grid__col">
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
              gap: '20px',
            }}
          >
            {cards.map((card, index) => (
              <CardComponent
                key={index}
                card={card}
                componentTheme={block?.theme}
                {...(!block?.theme && { colorIndex: index })}
              />
            ))}
          </div>
        </div>
      </div>
    </ComponentWrapper>
  );
}
